import { render } from "./Menu.vue?vue&type=template&id=15255ca4"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"
script.render = render

export default script